var EHDI = EHDI || Object.create(null);

EHDI.component = EHDI.component || Object.create(null);

EHDI.component.DragonflyObject = function() {
    EHDI.aka.Container.call(this);
	
    var _this = this;
    
    var _arma = EHDI.GAME.dbFactory.buildArmature("dragonfly");
    var _sprite = _arma.getDisplay();
    _sprite.scaleX = ( Math.random() < 0.5 ) ? -1 : 1;
    _this.addChild( _sprite );
    
    var _startPos = { x: 0, y: 0 };
    var _destPos = { x: 0, y: 0 };
    var _isShown = true;
    var _timeline = new TimelineMax( { autoRemoveChildren: true } );
    EHDI.GAME.gameScene.pauseManager.addTimelineInterrupt( _timeline );
    
    var _wanderTime = 0, _wanderThresh = EHDI.NumberUtil.randomRange( 4, 12 );
    var _hiddenTime = 0, _hiddenThresh = EHDI.NumberUtil.randomRange( 11, 33 );
    
    var onTouch = function(e){
        if( _timeline ){
            _timeline.kill();
        }
        EHDI.GAME.soundManager.playSFX("tap_dragonfly");
        _sprite.interactive = false;
        EHDI.GAME.achieveManager.updateDragonflyTapped();
        
        var distFromX;
        if( _sprite.position.x < EHDI.screen.viewWidth * 0.5 )    distFromX = _sprite.position.x / EHDI.screen.viewWidth;
        else                                                    distFromX = 1 - ( _sprite.position.x / EHDI.screen.viewWidth );
        
        var distFromY;
        if( _sprite.position.y < EHDI.screen.viewHeight * 0.5 )   distFromY = _sprite.position.y / EHDI.screen.viewHeight;
        else                                                    distFromY = 1 - ( _sprite.position.y / EHDI.screen.viewHeight );
        
        var midPos = {x: 0, y: 0}, destPos = {x: 0, y: 0};
        if( distFromX <= distFromY ){
            destPos.x = EHDI.screen.viewWidth;
            destPos.x *= ( _sprite.position.x < EHDI.screen.viewWidth * 0.5 ) ? -0.1 : 1.1;
            
            destPos.y = _sprite.position.y;
            destPos.y += EHDI.NumberUtil.randomRange( 25, 75 ) * ( (Math.random() < 0.5) ? -1 : 1 );
            
            midPos.x = EHDI.NumberUtil.randomRange( _sprite.position.x, destPos.x );
            midPos.y = destPos.y;
        }
        else{
            destPos.y = EHDI.screen.viewHeight;
            destPos.y *= ( _sprite.position.y < EHDI.screen.viewHeight * 0.5 ) ? -0.15 : 1.15;
            
            destPos.x = _sprite.position.x;
            destPos.x += EHDI.NumberUtil.randomRange( 50, 100 ) * ( (Math.random() < 0.5) ? -1 : 1 );
            
            midPos.y = EHDI.NumberUtil.randomRange( _sprite.position.y, destPos.y );
            midPos.x = destPos.x;
        }
        _sprite.scaleX = ( destPos.x < _sprite.position.x ) ? -1 : 1;
        
        _destPos.x = destPos.x;
        _destPos.y = destPos.y;
        
        _timeline
            .add( TweenMax.to(
                _sprite, 
                1.5, 
                { bezier: { type: "soft", values: [{x: midPos.x, y: midPos.y}, {x: destPos.x, y: destPos.y}] } }
            ) )
            .addCallback( function(){
                _isShown = false;
                _this.visible = false;
            }, "+=0", null );
    }
    
    this.setStartPos = function( x, y ){
        _startPos.x = x;
        _startPos.y = y;
        
        _sprite.position.set( x, y );
        
        if( Math.random() < 0.4 ){
            var distFromX;
            if( _sprite.position.x < EHDI.screen.viewWidth * 0.5 )    distFromX = _sprite.position.x / EHDI.screen.viewWidth;
            else                                                    distFromX = 1 - ( _sprite.position.x / EHDI.screen.viewWidth );

            var distFromY;
            if( _sprite.position.y < EHDI.screen.viewHeight * 0.5 )   distFromY = _sprite.position.y / EHDI.screen.viewHeight;
            else                                                    distFromY = 1 - ( _sprite.position.y / EHDI.screen.viewHeight );

            var midPos = {x: 0, y: 0}, destPos = {x: 0, y: 0};
            if( distFromX <= distFromY ){
                destPos.x = EHDI.screen.viewWidth;
                destPos.x *= ( _sprite.position.x < EHDI.screen.viewWidth * 0.5 ) ? -0.1 : 1.1;

                destPos.y = _sprite.position.y;
                destPos.y += EHDI.NumberUtil.randomRange( 25, 75 ) * ( (Math.random() < 0.5) ? -1 : 1 );
            }
            else{
                destPos.y = EHDI.screen.viewHeight;
                destPos.y *= ( _sprite.position.y < EHDI.screen.viewHeight * 0.5 ) ? -0.15 : 1.15;

                destPos.x = _sprite.position.x;
                destPos.x += EHDI.NumberUtil.randomRange( 50, 100 ) * ( (Math.random() < 0.5) ? -1 : 1 );
            }
            
            _destPos.x = destPos.x;
            _destPos.y = destPos.y;
            
            _sprite.position.set( destPos.x, destPos.y );
            _isShown = false;
            _this.visible = false;
        }
    }
    
   var update = function( dt ){
       if(EHDI.GAME.gameScene.pauseManager.isPaused) return;
       dt /= 1000;
       
       if( _isShown ){
            _wanderTime += dt;
            
            if( _wanderTime > _wanderThresh ){
                _wanderTime = 0;
                _wanderThresh = EHDI.NumberUtil.randomRange( 2, 8 );
                
                var destPos = {
                    x: _startPos.x + EHDI.NumberUtil.randomRange( -25, 25 ),
                    y: _startPos.y + EHDI.NumberUtil.randomRange( -25, 25 )
                }
                
                _sprite.scaleX = ( destPos.x < _sprite.position.x ) ? -1 : 1;
                
                _timeline.add( TweenMax.to( _sprite, 0.3, { x: destPos.x, y: destPos.y } ) );
            }
        }
        else{
            _hiddenTime += dt;
            
            if( _hiddenTime > _hiddenThresh ){
                _this.visible = true;
                _isShown = true;
                //_sprite.interactive = true;
                
                _hiddenTime = 0;
                _hiddenThresh = EHDI.NumberUtil.randomRange( 7, 21 );

                _wanderTime = 0;
                _wanderThresh = EHDI.NumberUtil.randomRange( 4, 10 );
                
                // TODO - something teleports the dragonfly to the start position, needs a fix
                // this fixes it... why though would it not be at this location??
                _sprite.position.x = _destPos.x;
                _sprite.position.y = _destPos.y;
                
                _sprite.scaleX = ( _startPos.x < _sprite.position.x ) ? -1 : 1;
                
                _timeline
                    .add( TweenMax.to( _sprite, 2, { x: _startPos.x, y: _startPos.y } ) )
                    .addCallback( function(){ _sprite.interactive = true; }, "+=1", null );
            }
        }
    }
   
   this.dispose = function(){
       EHDI.GAME.gameScene.pauseManager.removeTimelineInterrupt( _timeline );
       
       dragonBones.WorldClock.clock.remove( _arma );
       EHDI.GAME.updateManager.removeFrameListener( update );
   }
    
    _sprite.touchstart = _sprite.mousedown = onTouch;
    _sprite.interactive = true;
    _sprite.hitArea = new PIXI.Rectangle( -20, -35, 40, 40 );
    
    dragonBones.WorldClock.clock.add( _arma );
    _arma.animation.gotoAndPlay("idle_mid", -1, -1, 0);
    
    EHDI.GAME.updateManager.addFrameListener(update);
}

EHDI.component.DragonflyObject.prototype = Object.create(EHDI.aka.Container.prototype);